import { DatePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LetsikringRevision } from '@features/letregister/letsikring-revision.model';
import { DetailRowComponent } from '@shared/detail-row/detail-row.component';
import { Select } from 'primeng/select';

@Component({
  selector: 'app-letsikring-synkronisering',
  imports: [DatePipe, ReactiveFormsModule, Select, DetailRowComponent],
  templateUrl: './letsikring-synkronisering.component.html',
  styleUrl: './letsikring-synkronisering.component.css',
})
export class LetsikringSynkroniseringComponent {
  form = input.required<FormGroup>();
  editMode = input.required<boolean>();
  revision = input.required<LetsikringRevision>();

  synkroniseringStatusOptions = [
    { text: 'Data mismatch', value: 'DATA_MISMATCH' },
    { text: 'Data match', value: 'DATA_MATCH' },
    { text: 'Ukendt letsikring', value: 'UKENDT_LETSIKRING' },
    { text: 'Ingen oplysninger', value: 'INGEN_OPLYSNINGER' },
    { text: 'Tilbagekaldt', value: 'TILBAGEKALDT' },
  ];
}
